import { Form, Offcanvas, Button, Row, Col, InputGroup } from "react-bootstrap";
import { CiSquarePlus } from "react-icons/ci";
import { useEffect, useState } from "react";
import { GoTrash } from "react-icons/go";
import SitePilotAddonsEditor from "./SitePilotAddonsEditor";
import { addonsServices } from "../../../APIServices/SitePilotManagement/addonsServices";
import { FiDollarSign, FiPlus } from "react-icons/fi";
import UseToggle from "../../../Hooks/UseToggle";
import UploadedImageModal from "../SitePilotIntegration/UploadedImageModal";
import { FaTrashAlt } from "react-icons/fa";

const AddSitePilotAddons = ({ Show, Hide, Title, getSitePilotAddonsList }) => {
  const [hourlyPrice, setHourlyPrice] = useState(0);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [yearlyPrice, setYearlyPrice] = useState(0);
  const [icon, setIcon] = useState("");
  const [title, setTitle] = useState("");
  const [overview, setOverview] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [banner, setBanner] = useState([]);
  const [bannerIndex, setBannerIndex] = useState(null);
  const [tags, setTags] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sliders, setSliders] = useState(false);
  const [chatWithUs, setChatWithUs] = useState(false);
  const [scheduleCall, setScheduleCall] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const toggles = UseToggle();

  const addNewSitePilotAddons = async () => {
    setLoader(true);
    let userData = {};
    userData.title = title;
    userData.banners = banner
    userData.hourlyPrice = hourlyPrice
    userData.monthlyPrice = monthlyPrice
    userData.yearlyPrice = yearlyPrice
    userData.icon = icon
    userData.shortDescription = shortDescription;
    userData.overview = overview;
    userData.sliders = sliders;
    userData.chatWithUs = chatWithUs;
    userData.scheduleCall = scheduleCall;
    userData.faqs = faqs;
    userData.tags = tags;
    let data = await addonsServices.addNewSitePilotAddon(userData);
    if (data?.statusCode === 200) {
      getSitePilotAddonsList();
      clearData();
    }
    setLoader(false);
  };

  const clearData = () => {
    setTitle("");
    setHourlyPrice("");
    setMonthlyPrice("");
    setYearlyPrice("");
    setIcon("");
    setShortDescription("");
    setOverview("");
    setTags([]);
    setBanner([]);
    setLoader(false);
    Hide();
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  const hasEmptyTag = () => {
    return tags?.some((tag) => tag.trim() === "");
  };


  const addFaqsRow = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const removeFaqsRow = (index) => {
    setFaqs(faqs.filter((_, i) => i !== index));
  };

  const handleFaqsChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  const isFaqInvalid = () => {
    return faqs.some(
      (item) =>
        !item.question?.trim() || !item.answer?.trim()
    );
  };

  const addBannerUrl = (url) => {
    setBanner((prev) => [...prev, url]);
  };

  const updateBannerUrl = (newUrl) => {
    setBanner((prev) =>
      prev.map((item, i) => (i === bannerIndex ? newUrl : item))
    );
  };

  const removeBannerUrl = (index) => {
    setBanner((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!Show) {
      setTitle("");
      setHourlyPrice("");
      setMonthlyPrice("");
      setYearlyPrice("");
      setIcon("");
      setShortDescription("");
      setOverview("");
      setTags([]);
      setBanner([]);
      setLoader(false);
    }
  }, [Show]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 750 }}>
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Row>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Icon
              </Form.Label>
              <div title="Add Icon">
                <Button
                  onClick={toggles.setToggle}
                  variant="light"
                  className="w-100 border hstack gap-2 justify-content-center"
                  style={{ height: 108 }}
                >
                  {icon ? (
                    <img className="w-auto h-50" src={icon} />
                  ) : (
                    <>
                      <FiPlus /> Add Icon
                    </>
                  )}
                </Button>
              </div>
            </Form.Group>
          </Col>
          <Col md={9}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Title
              </Form.Label>
              <Form.Control
                type="text"
                style={{ fontSize: 12 }}
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Col>
              <Form.Group className="mb-3 hstack gap-2">
                <Form.Check
                  type="switch"
                  checked={chatWithUs}
                  onChange={(e) => setChatWithUs(e.target.checked)}
                  style={{ fontSize: 12 }}
                />
                <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                  Chat With Us (Button)
                </Form.Label>
              </Form.Group>
              <Form.Group className="mb-3 hstack gap-2">
                <Form.Check
                  type="switch"
                  checked={scheduleCall}
                  onChange={(e) => setScheduleCall(e.target.checked)}
                  style={{ fontSize: 12 }}
                />
                <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                  Schedule Call (Button)
                </Form.Label>
              </Form.Group>
            </Col>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <div className="hstack gap-2 mb-2">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Banner
            </Form.Label>
            <div className="vr"></div>
            <Form.Group className="mb-1 hstack gap-2">
              <Form.Check
                type="switch"
                checked={sliders}
                onChange={(e) => setSliders(e.target.checked)}
                style={{ fontSize: 12 }}
              />
              <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                Slider
              </Form.Label>
            </Form.Group>
          </div>
          <Row className="g-2">
            {banner?.map((icon, index) => (
              <Col key={index} md={3}>
                <div title="Remove Banner" className="position-relative">
                  <Button
                    onClick={() => { toggles.setToggle2(); setBannerIndex(index) }}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    <img className="w-auto h-50" src={icon} />
                  </Button>
                  <div className="bg-white position-absolute rounded-circle" style={{top: -10, right: -3}}>
                    <Button variant="outline-danger" className="rounded-circle p-0" style={{width: 25}} onClick={() => removeBannerUrl(index)}>
                      <FaTrashAlt style={{fontSize: 12}}/>
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
            <Col md={3}>
              <div title="Add Banner">
                <Button
                  onClick={toggles.setToggle1}
                  variant="light"
                  className="w-100 border hstack gap-2 justify-content-center"
                  style={{ height: 108 }}
                >
                  <FiPlus /> Add Banner
                </Button>
              </div>
            </Col>
          </Row>
        </Form.Group>
        <Row>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Hourly Price
              </Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FiDollarSign style={{ fontSize: 12 }} />
                </InputGroup.Text>
                <Form.Control
                  type="number"
                  onChange={(e) => setHourlyPrice(e.target.value)}
                  value={hourlyPrice}
                  placeholder="Enter Hourly Price"
                  style={{ fontSize: 12 }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Monthly Price
              </Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FiDollarSign style={{ fontSize: 12 }} />
                </InputGroup.Text>
                <Form.Control
                  type="number"
                  onChange={(e) => setMonthlyPrice(e.target.value)}
                  value={monthlyPrice}
                  placeholder="Enter Monthly Price"
                  style={{ fontSize: 12 }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Yearly Price
              </Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FiDollarSign style={{ fontSize: 12 }} />
                </InputGroup.Text>
                <Form.Control
                  type="number"
                  onChange={(e) => setYearlyPrice(e.target.value)}
                  value={yearlyPrice}
                  placeholder="Enter Yearly Price"
                  style={{ fontSize: 12 }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Short Description
          </Form.Label>
          <Form.Control
            as="textarea"
            style={{ fontSize: 12 }}
            placeholder="Enter Short Description"
            value={shortDescription}
            onChange={(e) => setShortDescription(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Overview
          </Form.Label>
          <SitePilotAddonsEditor
            editorValue={overview}
            setEditorValue={setOverview}
          />
        </Form.Group>
        <Form.Group>
          <div className="hstack gap-2 mb-2">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              FAQs
            </Form.Label>
            <CiSquarePlus
              title="Add More"
              onClick={addFaqsRow}
              className="mb-1 text-success CP"
            />
          </div>

          <Row>
            {faqs?.map((item, index) => (
              <Col md={6} className="mb-2" key={index}>
                <InputGroup className="mb-1">
                  <Form.Control
                    placeholder="Enter Question"
                    value={item.question}
                    style={{ fontSize: 12 }}
                    onChange={(e) =>
                      handleFaqsChange(index, "question", e.target.value)
                    }
                  />
                </InputGroup>

                <InputGroup>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter Answer"
                    value={item.answer}
                    style={{ fontSize: 12 }}
                    onChange={(e) =>
                      handleFaqsChange(index, "answer", e.target.value)
                    }
                  />
                  <InputGroup.Text>
                    <GoTrash
                      style={{ fontSize: 12 }}
                      className="text-danger CP"
                      title="Delete"
                      onClick={() => removeFaqsRow(index)}
                    />
                  </InputGroup.Text>
                </InputGroup>
              </Col>
            ))}
          </Row>
        </Form.Group>
        <Form.Group>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Tags
            </Form.Label>
            <CiSquarePlus
              title="Add More"
              onClick={addTagsRow}
              className="mb-1 text-success CP"
            />
          </div>
          <Row>
            {tags?.map((tag, index) => {
              return (
                <Col md={3} className="mb-2">
                  <InputGroup key={index}>
                    <Form.Control
                      placeholder="Enter Tag"
                      value={tag}
                      style={{ fontSize: 12 }}
                      onChange={(e) => handleTagsChange(index, e.target.value)}
                    />
                    <InputGroup.Text>
                      <GoTrash
                        style={{ fontSize: 12 }}
                        className="text-danger CP"
                        title="Delete"
                        onClick={() => removeTagsRow(index)}
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              );
            })}
          </Row>
        </Form.Group>
      </Offcanvas.Body>
      <div className="d-flex justify-content-end gap-2 p-2">
        <Button variant="light" style={{ fontSize: 12 }} onClick={clearData}>
          Cancel
        </Button>

        <Button
          disabled={
            !icon ||
            !title ||
            !monthlyPrice ||
            !yearlyPrice ||
            banner?.length === 0 ||
            !shortDescription ||
            !overview ||
            loader ||
            isFaqInvalid() ||
            hasEmptyTag()
          }
          onClick={addNewSitePilotAddons}
          style={{ fontSize: 12 }}
        >
          Submit
        </Button>
      </div>
      <UploadedImageModal
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title={`Media Library`}
        onSelect={(icon) => setIcon(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title={`Media Library`}
        onSelect={(icon) => addBannerUrl(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        Title={`Media Library`}
        onSelect={(icon) => updateBannerUrl(icon)}
      />
    </Offcanvas>
  );
};

export default AddSitePilotAddons;
